import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["variant", "disabled", "error", "children", "$css"];
import React from 'react';
import { css } from 'styled-components';
import { COLORS, TYPOGRAPHY } from '../../../themes';
import { Span } from '../../Styled';
import { flex } from '../../../styling';
import { ErrorLineSmall } from '../../svg';

var HelperText = function HelperText(_ref) {
  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'primary' : _ref$variant,
      disabled = _ref.disabled,
      error = _ref.error,
      children = _ref.children,
      $css = _ref.$css,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Span, _extends({
    $css: css(["user-select:none;", " ", ";color:", ";", ""], flex('flex-start', 'flex-start'), variant === 'primary' ? TYPOGRAPHY.S_SEMIBOLD : TYPOGRAPHY.S, error ? COLORS.NEGATIVE_500 : disabled ? COLORS.NEUTRAL_300 : COLORS.NEUTRAL_500, $css)
  }, rest), error && /*#__PURE__*/React.createElement(ErrorLineSmall, {
    "aria-hidden": true,
    $css: css(["flex:0 0 auto;margin-right:8px;margin-top:2px;"]),
    color: COLORS.NEGATIVE_500
  }), children);
};

export default HelperText;